"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widget_helpers_1 = require("../util/widget-helpers");
var compat_1 = require("../util/compat");
var _1 = require("../util/_");
function handleFocus(inst, event, didHandle, willHandle) {
    _handleFocus(inst, true, event, didHandle, willHandle);
}
exports.handleFocus = handleFocus;
function handleBlur(inst, event, didHandle, willHandle) {
    _handleFocus(inst, false, event, didHandle, willHandle);
}
exports.handleBlur = handleBlur;
function _handleFocus(inst, focused, event, didHandle, willHandle) {
    var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
    if (handler && event) {
        event.persist();
    }
    if (willHandle && willHandle.call(inst, focused, event) === false) {
        return;
    }
    inst.setTimeout('focus', function () {
        compat_1.batchedUpdates(function () {
            if (didHandle) {
                didHandle.call(inst, focused, event);
            }
            if (focused !== inst.state.focused) {
                widget_helpers_1.notify(handler, event);
                if (_1.has(inst, '_isMounted') && inst._isMounted || inst.isMounted()) {
                    inst.setState({ focused: focused });
                }
            }
        });
    });
}
function FocusMixin(_a) {
    var willHandle = _a.willHandle, didHandle = _a.didHandle;
    return {
        //FIXME @widgetEnabled
        handleBlur: function (event) {
            _handleFocus(this, false, event, didHandle, willHandle);
        },
        //FIXME @widgetEnabled
        handleFocus: function (event) {
            _handleFocus(this, true, event, didHandle, willHandle);
        }
    };
}
exports.default = FocusMixin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/mixins/focus-mixin.js
// module id = 68
// module chunks = 0 1 2 3 4 5 6